import React, { Component } from 'react';
import strings from '../locales/';

import TitleMain from '../common/titleMain';
import Label from '../common/label';
import CircularIndicator from '../common/indicators/circularIndicator';

const TopTableButtons = props =>
  (
    <div className={"top-table-buttons " + props.className}>
      <TitleMain
        className={'flows-list'}
        title={"Listado de solicitudes"}
      />
      <div className="actions-container">
        <div className="actions-inner-container">
          <div className="left-button-container">
            <div className={"box-form"}>
              <div className={'normal_button'} onClick={props.handleSaveFlowActions}>
                <div>{"Enviar"}</div>
              </div>
            </div>
          </div>
          <div className="middle-stats-container">
            <CircularIndicator
              id={"pending-flows-stat"}
              size={45}
              max={100}
              value={props.data.pendingFlowRequests}
              forceValue={100}
              fill={true}
              thickness={2}
              fontSize={"22px"}
              valueFormat={{ type: 'NUMBER', format: '.0f' }}
            />
            <Label 
              label={"Solicitudes Pendientes"} 
              className={"pending-flows-title"}
            />      
          </div>
          <div className="right-button-container">
            <div className={"box-form"}>
              <div className={'normal_button'} onClick={props.handleViewFlows}>
                <div>{"Ver solicitudes"}</div>
              </div>
            </div>
            <div className={"box-form"}>
              <div className={'normal_button'} onClick={props.handleDownloadReports}>
                <div>{"Descargar reportes"}</div>
              </div>
            </div>
          </div>        
        </div>      
      </div>
    </div>
  );

export default TopTableButtons;



// WEBPACK FOOTER //
// ./source/client/components/flow_admin_detail/topTableButtons.jsx